import {Rect} from "react-konva";
import {useSelectionRectangle} from "@/tabletop/selection/SelectionRectangleHooks.ts";


export default function SelectionView() {
    const {selectionRectangle} = useSelectionRectangle()
    if (!selectionRectangle.visible) return null
    return (
        <Rect
            x={Math.min(selectionRectangle.x1, selectionRectangle.x2)}
            y={Math.min(selectionRectangle.y1, selectionRectangle.y2)}
            width={Math.abs(selectionRectangle.x2 - selectionRectangle.x1)}
            height={Math.abs(selectionRectangle.y2 - selectionRectangle.y1)}
            fill="rgba(174, 223, 255, 0.3)"
            stroke="#6badd9"
            strokeWidth={2}
            dash={[5, 5]}
            listening={false}
        />
    )
}
